import React, { useState, useEffect } from 'react';
import { Card, Form, Select, Switch, Col, Row } from 'antd';

export interface KpiCardsConfig {
    fields: string[];
    aggregateChildren: boolean;
    showChildBreakdown: boolean;
}

const DEFAULT_KPI_CARDS_CONFIG: KpiCardsConfig = {
    fields: [],
    aggregateChildren: true,
    showChildBreakdown: true,
};

interface Props {
    initialConfig?: Partial<KpiCardsConfig>;
    fieldOptions?: Array<{ label: string; value: string }>;
    onChange: (config: KpiCardsConfig) => void;
}

export const SectionConfigKpiCards: React.FC<Props> = ({ initialConfig, fieldOptions, onChange }) => {
    const [config, setConfig] = useState<KpiCardsConfig>({
        ...DEFAULT_KPI_CARDS_CONFIG,
        ...initialConfig,
    });

    const updateField = (field: keyof KpiCardsConfig, value: any) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);
        onChange(newConfig);  // Call onChange directly to avoid infinite loop
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Form.Item label="KPI fields to show">
                <Select
                    mode="multiple"
                    allowClear
                    options={fieldOptions || []}
                    value={config.fields}
                    onChange={(vals) => updateField('fields', vals)}
                />
            </Form.Item>
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item label="Aggregate children">
                        <Switch
                            checked={config.aggregateChildren}
                            onChange={(checked) => updateField('aggregateChildren', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Show child breakdown">
                        <Switch
                            checked={config.showChildBreakdown}
                            onChange={(checked) => updateField('showChildBreakdown', checked)}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default SectionConfigKpiCards;

